/**
 * Utilitários para debug de autenticação
 */

export const debugAuthState = () => {
  console.group('🔍 Auth Debug Info');
  
  // Verificar auth-storage (Zustand)
  const authStorage = localStorage.getItem('auth-storage');
  if (authStorage) {
    try {
      const parsed = JSON.parse(authStorage);
      console.log('✅ Zustand auth-storage:', {
        hasUser: !!parsed.state?.user,
        userEmail: parsed.state?.user?.email,
        isActive: parsed.state?.user?.is_active,
        isStaff: parsed.state?.user?.is_staff,
        isSuperuser: parsed.state?.user?.is_superuser,
        hasAccessToken: !!parsed.state?.accessToken,
        hasRefreshToken: !!parsed.state?.refreshToken,
        tokenExpiry: parsed.state?.tokenExpiry ? new Date(parsed.state.tokenExpiry).toLocaleString() : null,
        isAuthenticated: parsed.state?.isAuthenticated
      });
      
      // Verificar se token está expirado
      if (parsed.state?.tokenExpiry) {
        const isExpired = parsed.state.tokenExpiry < Date.now();
        console.log(`Token ${isExpired ? '❌ EXPIRADO' : '✅ VÁLIDO'}`);
      }
    } catch (e) {
      console.error('❌ Erro ao parsear auth-storage:', e);
    }
  } else {
    console.log('❌ Nenhum auth-storage encontrado');
  }
  
  // Verificar tokens diretos (retrocompatibilidade)
  const directAccessToken = localStorage.getItem('accessToken');
  const directRefreshToken = localStorage.getItem('refreshToken');
  
  console.log('📦 Tokens diretos:', {
    hasAccessToken: !!directAccessToken,
    hasRefreshToken: !!directRefreshToken
  });
  
  // Listar todas as chaves do localStorage
  console.log('📋 Todas as chaves do localStorage:', Object.keys(localStorage));
  
  console.groupEnd();
};

export const clearAllAuth = () => {
  console.log('🧹 Limpando toda autenticação...');
  localStorage.removeItem('auth-storage');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  console.log('✅ Autenticação limpa');
};

export const fixAuthSync = () => {
  console.log('🔧 Sincronizando tokens...');
  
  const authStorage = localStorage.getItem('auth-storage');
  if (authStorage) {
    try {
      const parsed = JSON.parse(authStorage);
      if (parsed.state?.accessToken && parsed.state?.refreshToken) {
        // Sincronizar com chaves diretas
        localStorage.setItem('accessToken', parsed.state.accessToken);
        localStorage.setItem('refreshToken', parsed.state.refreshToken);
        console.log('✅ Tokens sincronizados');
      } else {
        console.log('❌ Nenhum token encontrado no auth-storage');
      }
    } catch (e) {
      console.error('❌ Erro ao sincronizar:', e);
    }
  }
};

// Exportar para o window para uso no console
if (typeof window !== 'undefined') {
  (window as any).authDebug = {
    debug: debugAuthState,
    clear: clearAllAuth,
    fix: fixAuthSync
  };
  
  console.log('🛠️ Auth Debug Tools disponíveis:');
  console.log('  authDebug.debug() - Mostrar estado da autenticação');
  console.log('  authDebug.clear() - Limpar toda autenticação');
  console.log('  authDebug.fix()   - Sincronizar tokens');
}